module.exports = __webpack_public_path__ + "img/flag-gb.f66753ee.svg";